import { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLeftFromBracket,
  faShieldCheck,
  faUser,
  faCog,
} from "@fortawesome/pro-solid-svg-icons";
import { faBars } from "@fortawesome/pro-regular-svg-icons";
import { authInfo, authLogout } from "@/entities";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { TopMenuNav } from "./top-menu-nav";
import { MobileMenu } from "./mobile-menu";

function HeaderLogo() {
  return (
    <div className="shrink-0 mr-20">
      <Link href={"/"}>
        {/* PC Logo (>= 991px) */}
        <div className="relative w-28 h-[23px] hidden min-[991px]:flex">
          <Image
            src="/assets/images/logo/headLogo.svg"
            alt="Symbol Logo"
            fill
            style={{ objectFit: "contain" }}
          />
        </div>
        {/* Mobile/Tablet Logo (< 991px) */}
        <div className="relative w-24 h-5 flex min-[991px]:hidden">
          <Image
            src="/assets/images/logo/headBlackLogo.svg"
            alt="Symbol Logo"
            fill
            style={{ objectFit: "contain" }}
          />
        </div>
      </Link>
    </div>
  );
}
function ActionButtons() {
  const router = useRouter();

  const logoutMutation = useMutation({
    mutationFn: authLogout,
    onSuccess: () => {
      window.location.href = "/auth/login";
      // router.push("/auth/login");
    },
    onError: (error) => {
      console.error(error);
    },
  });

  const onLogout = () => {
    if (!confirm("로그아웃 하시겠습니까?")) return;
    if (logoutMutation.isPending) return;
    logoutMutation.mutate();
  };

  const { error, isLoading, data } = useQuery({
    queryKey: ["authInfo"],
    queryFn: authInfo,
  });

  if (isLoading) return <></>;
  if (error) return <></>;

  const UserAuthButton = data?.result ? (
    <>
      {data?.result?.role === "admin" && (
        <a
          href="/admin/main"
          className="flex items-center justify-center w-12 h-12 rounded-full bg-[#3C3C3C] text-white"
          title="관리자"
        >
          <FontAwesomeIcon icon={faCog} className="text-lg" />
        </a>
      )}
      <button
        onClick={onLogout}
        className="flex items-center justify-center w-12 h-12 rounded-full bg-[#3C3C3C] text-white"
        disabled={logoutMutation.isPending}
        title="로그아웃"
      >
        <FontAwesomeIcon icon={faLeftFromBracket} className="text-lg" />
      </button>
    </>
  ) : (
    <button
      type="button"
      onClick={() => router.push("/auth/login")}
      className="flex items-center justify-center w-12 h-12 rounded-full bg-[#3C3C3C]"
      title="로그인"
    >
      <FontAwesomeIcon icon={faUser} className="text-lg" color="white" />
    </button>
  );

  return (
    <div className="hidden items-center justify-end flex-none min-[991px]:flex space-x-2">
      {/* Web Accessibility Check Button */}
      <button
        className="
          flex items-center justify-center h-12 rounded-full text-white bg-[#4A9CA0]
          w-12 xl:w-auto
          xl:px-4
        "
        onClick={() => {
          window.location.href = "http://wa.wezon.co.kr/app/main/index";
        }}
      >
        <FontAwesomeIcon
          icon={faShieldCheck}
          className="text-lg !m-0 xl:!mr-2"
        />
        <p className="medium-text-18 hidden xl:block">웹접근성 검사</p>
      </button>

      {/* Conditional User/Logout Button */}
      {UserAuthButton}
    </div>
  );
}
function MobileMenuToggle() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <>
      <div className="min-[991px]:hidden flex">
        <button
          aria-label="Toggle Menu"
          onClick={() => setIsMenuOpen(true)}
          className="cursor-pointer p-2 rounded-full group hover:bg-gray-100 transition-colors duration-200"
        >
          <FontAwesomeIcon
            icon={faBars}
            color="var(--color-midGray-30)"
            className="text-lg 
            transition-transform duration-300 ease-in-out
            group-hover:rotate-90
          "
          />
        </button>
      </div>
      {isMenuOpen && <MobileMenu onClose={() => setIsMenuOpen(false)} />}
    </>
  );
}

export function AppHeader() {
  return (
    <header className="flex flex-row">
      <div className="fixed top-0 z-[1020] left-0 right-0 bg-[#ffffffee] shadow-2xs min-[991px]:shadow-md transition-shadow duration-300 ease-linear h-15 min-[991px]:h-20 xl:h-24">
        <div className="max-w-full xl:max-w-[1280px] mx-auto h-full flex justify-between items-center px-4 xl:px-0 space-x-5">
          {/* 로고 */}
          <HeaderLogo />
          {/* 메뉴 영역 */}
          <TopMenuNav />
          {/* 사이드버튼 */}
          <div className="flex items-center">
            <ActionButtons />
            <MobileMenuToggle />
          </div>
        </div>
      </div>
    </header>
  );
}
